/* istanbul ignore file */
/**
 * By Prashant Bhatt (pbhatt@svb.com)
 *
 * This is a reusable higher order component if wrapped on any component
 * will handle token expiry/regenerate using existing browse api handler logic
 * and returns anon token which will be available in the props of that wrapped component (See src/pages/HomePage.js for example)
 * Very handy for making sure anon token is available before component loads
 * Note:Use only for parent component/template and then pass this token as prop to the child if it requires use of anon token
 * Solves issue of token expiry/handling without reloading the whole app
 *
 *
 */

import React, { useEffect, useState } from 'react';
import Loading from '@svb/api-loading-component/dist/components/index';
import { regenTokenifExpired } from '../helpers/utilityFunctions';

const AnnonTokenWrapper = (UnderlyingComp) => {
  //returns new functional component with token available in the prop
  const UnderlyingCompWithAnonToken = (props) => {
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);
    //get already existing token or regenerate token (can add multiple retry logic on fail but currently executes only one time on failure)
    useEffect(() => {
      const anontoken = regenTokenifExpired();
      anontoken.then(async (token) => {
        setToken(token);
        setLoading(false);
      });
    }, []);

    return loading ? <Loading /> : <UnderlyingComp {...props} token={token} />;
  };
  return UnderlyingCompWithAnonToken;
};

export default AnnonTokenWrapper;
